var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0556 59H49.9444C53.0127 59 55.5 56.5127 55.5 53.4444V14.5556C55.5 11.7778 53.0127 9 49.9444 9H11.0556C7.98731 9 5.5 11.4873 5.5 14.5556V53.4444C5.5 56.5127 7.98731 59 11.0556 59ZM11.0556 59L41.6111 28.4444L55.5 42.3333M24.9444 24.2778C24.9444 26.579 23.079 28.4444 20.7778 28.4444C18.4766 28.4444 16.6111 26.579 16.6111 24.2778C16.6111 21.9766 18.4766 20.1111 20.7778 20.1111C23.079 20.1111 24.9444 21.9766 24.9444 24.2778Z",
    stroke: "#F8A21E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 12,
    r: 12,
    fill: "#11203A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52 18C52 18.2761 52.2239 18.5 52.5 18.5C52.7761 18.5 53 18.2761 53 18H52ZM52.8536 5.64644C52.6583 5.45118 52.3417 5.45118 52.1464 5.64644L48.9645 8.82842C48.7692 9.02369 48.7692 9.34027 48.9645 9.53553C49.1597 9.73079 49.4763 9.73079 49.6716 9.53553L52.5 6.7071L55.3284 9.53553C55.5237 9.73079 55.8403 9.73079 56.0355 9.53553C56.2308 9.34027 56.2308 9.02369 56.0355 8.82842L52.8536 5.64644ZM53 18V6H52V18H53Z",
    fill: "#26C1E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageUpload);
export default __webpack_public_path__ + "static/media/ImageUpload.9a0f9c5a42e9d34c926d5a3410065392.svg";
export { ForwardRef as ReactComponent };